import { Sl1ReconWindow, sl1WindowIsAllTime } from "shared/sl1ImportData"

/**
 * How a recon window reads on screen (LOCKER-382).
 *
 * Three surfaces render this — the fleet table's qualifier, the job history's
 * window column, and the report header — and before this they each interpolated
 * `${fromDate} → ${toDate}` inline. Once an end can be `null` that produces
 * `null → 2024-08-09`, which is not a date range and not a bug an operator can
 * report usefully. One implementation, so the three cannot disagree.
 *
 * Takes `t` rather than importing i18n so it stays a pure function of its inputs
 * and can be tested by passing a stub.
 */
export const sl1WindowLabel = (
  window: Sl1ReconWindow | undefined,
  t: (key: string, opts?: Record<string, unknown>) => string,
): string => {
  // An ABSENT window is not the same as an unbounded one: it means nobody has
  // reconned this provider, and saying "All time" would claim a measurement that
  // was never taken.
  if (!window) return "—"
  if (sl1WindowIsAllTime(window)) return t("sl1WindowAllTime")
  if (window.fromDate && !window.toDate)
    return t("sl1WindowSince", { from: window.fromDate })
  if (!window.fromDate && window.toDate)
    return t("sl1WindowUntil", { to: window.toDate })
  return `${window.fromDate} → ${window.toDate}`
}
